export default "__VITE_ASSET__DSrDVwQe__"